<template>
	<div>
		<div class="flex">
			<div>
				<el-date-picker type="daterange" v-model="query.time" @change="getList()"
					value-format="yyyy-MM-dd"></el-date-picker>
				<!-- <el-button @click="adialog=true" type="primary">添加用户</el-button> -->
				<el-button size="small" type="primary" @click="expor()" style="margin-left: 20px;">导出用户</el-button>
			</div>
			<div>
				<!-- 				<el-upload
				  class="upload-demo"
				  action="https://jsonplaceholder.typicode.com/posts/">
				  <el-button type="primary" style="margin-left: 10px;">上传用户</el-button>
				</el-upload> -->
			</div>
		</div>
		<el-table :data="tableData" :cell-style="{'text-align':'center'}" :header-cell-style="{'text-align':'center'}">
			<el-table-column label="头像">
				<template slot-scope="scope">
					<el-image :src="scope.row.avatarUrl" style="width: 50px;height: 50px;"></el-image>
				</template>
			</el-table-column>
			<el-table-column label="昵称">
				<template slot-scope="scope">
					{{scope.row.nickName | nu}}
				</template>
			</el-table-column>
			<el-table-column prop="telphone" label="手机号"></el-table-column>
			<el-table-column label="所属分组">
				<template slot-scope="scope">
					{{scope.row.groupName | nu}}
				</template>
			</el-table-column>
			<el-table-column prop="createTime" label="添加时间" sortable=""></el-table-column>
			<el-table-column prop="time" label="分销额">
				<template slot-scope="scope">
					<!-- {{scope.row.type==0?'':'￥'}}{{scope.row.type==0?(scope.row.rate*100).toFixed(2):(scope.row.money/100).toFixed(2)}}{{scope.row.type==0?'%':''}} -->
					<div style="font-size: 16px;">
						￥{{scope.row.money==null?'0.00':(scope.row.money/100).toFixed(2)}}
					</div>
				</template>
			</el-table-column>
			<!-- 			<el-table-column label="操作">
				<template slot-scope="scope">
					<el-button @click="udialog=true" type="text">详情</el-button>
					<el-button type="text" style="color: red;margin-left: 20px;" >移除</el-button>
				</template>
			</el-table-column> -->
		</el-table>
		<div class="page">
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
				:current-page="query.pageNum" :page-sizes="[10, 20, 50,100,9999]" :page-size="query.pageSize"
				layout="total, sizes, prev, pager, next, jumper" :total="query.total">
			</el-pagination>
		</div>
		<el-dialog :visible.sync="adialog" width="60%" title="添加用户">
			<el-table :cell-style="{'text-align':'center'}" :header-cell-style="{'text-align':'center'}">
				<el-table-column label="昵称">
					<template slot-scope="scope">
						{{scope.row.name | nu}}
					</template>
				</el-table-column>
				<el-table-column label="手机号">
					<template slot-scope="scope">
						{{scope.row.telphone | nu}}
					</template>
				</el-table-column>
			</el-table>
		</el-dialog>
		<el-dialog :visible.sync="udialog" width="60%">
			<!-- 			<el-row>
				<el-col :span="3">
					
				</el-col>
				<el-col :span="6">
					<div class="flex">
						<div></div>
						<div></div>
					</div>
				</el-col>
				<el-col :span="5">
					<div>￥</div>
					<div></div>
				</el-col>
				<el-col :span="5">
					<div></div>
					<div></div>
				</el-col>
				<el-col :span="5">
					<div>￥</div>
					<div></div>
				</el-col>
			</el-row> -->
			<el-row>
				<el-table>
					<el-table-column label="时间"></el-table-column>
					<el-table-column label="订单id"></el-table-column>
					<el-table-column label="购买项目"></el-table-column>
					<el-table-column label="用户"></el-table-column>
					<el-table-column label="手机号"></el-table-column>
					<el-table-column label="消费总额"></el-table-column>
					<el-table-column label="提成"></el-table-column>
				</el-table>
			</el-row>
		</el-dialog>
	</div>
</template>

<script>
	import {
		url
	} from '../../../utils/index.js'
	export default {
		data() {
			return {
				url: url(),
				adialog: false,
				udialog: false,
				tableData: [],
				query: {
					pageNum: 1,
					pageSize: 10,
					total: 0,
					time: '',
					startTime: '',
					endTime: ''
				}
			}
		},
		filters: {
			nu(val) {
				if (val == null || val == "") {
					return "暂无"
				} else {
					return val
				}
			}
		},
		mounted() {
			this.getList()
			// util.$on('test',(test)=>{//修改分销组时被调用
			//         // console.log(test);
			//         this.getList();
			//     })
		},
		methods: {
			getList() {
				var a = "?pageNum=" + parseInt(this.query.pageNum - 1) + "&pageSize=" + this.query.pageSize
				var b = ""
				if (this.query.time != '' && this.query.time != undefined) {
					this.query.startTime = this.query.time[0]
					this.query.endTime = this.query.time[1]
					b = "&startTime=" + this.query.startTime + "&endTime=" + this.query.endTime
					a += b
				}
				this.$http.get("dDistUser/list" + a).then(res => {
					this.tableData = res.body.data
					this.query.total = res.body.total
				})
			},
			expor() {
				var b = ""
				if (this.query.time != '' && this.query.time != undefined) {
					this.query.startTime = this.query.time[0]
					this.query.endTime = this.query.time[1]
					b = "?&startTime=" + this.query.startTime + "&endTime=" + this.query.endTime
				} else {
					b = "?pageNum=" + parseInt(this.query.pageNum - 1) + "&pageSize=" + this.query.pageSize
				}
				window.location.assign(this.url + "dDistUser/expor" + b)
			},
			handleSizeChange(val) {
				this.query.pageSize = val
				this.getList()
			},
			handleCurrentChange(val) {
				this.query.pageNum = val
				this.getList()
			}
		}
	}
</script>

<style lang="less" scoped>
	.flex {
		display: flex;
	}

	.page {
		width: 100%;
		text-align: center;
		margin-top: 20px;
	}
</style>